<div class="main-content">
	<div class="intro-container">
		<div class="intro-items-container">
			<div class="intro-item">
				<div class="intro-item__image">
					<svg-inline class="img-responsive" [src]="'/assets/images/savings_plan_modal_intro_gear.svg'" alt="safe" />
				</div>
				<div class="intro-item__texts">
					<div class="intro-item__texts__title">{{
						"recurring_buy_modal_intro_how_it_works_title" | translate
					}}</div>
					<div class="intro-item__texts__info">
						{{ "recurring_buy_modal_intro_how_it_works_description" | translate }}
					</div>
				</div>
			</div>

			<div class="intro-item">
				<div class="intro-item__image">
					<svg-inline class="img-responsive" [src]="'/assets/images/savings_plan_modal_lamp.svg'" alt="safe" />
				</div>
				<div class="intro-item__texts">
					<div class="intro-item__texts__title">
						{{ "recurring_buy_modal_intro_proven_strategy_title" | translate }}
					</div>
					<div class="intro-item__texts__info">
						{{ "recurring_buy_modal_intro_proven_strategy_description" | translate }}
					</div>
				</div>
			</div>

			<div class="intro-item">
				<div class="intro-item__image">
					<svg-inline class="img-responsive" [src]="'/assets/images/savings_plan_modal_chart.svg'" alt="safe" />
				</div>
				<div class="intro-item__texts">
					<div class="intro-item__texts__title">
						{{ "recurring_buy_modal_intro_start_investing_title" | translate }}
					</div>
					<div class="intro-item__texts__info">
						{{ "uk_finprom_recurring_buy_modal_intro_start_investing_description" | translate }}
					</div>
				</div>
			</div>
		</div>
	</div>
	<button class="btn btn-primary get-started-btn" (click)="onButtonClicked.emit()">
		{{ "recurring_buy_modal_intro_get_started_button" | translate }}
	</button>
</div>
